import { useAppSelector } from '../../app/hooks'
import { useLocationByIdQuery } from '../../app/redux-fetch/apiCoreQuery'
import SpinnerModalBlock from '../../components/Spinner/SpinnerModalBlock'


import { fetchLoggedInUserSelector } from '../selectors'
import { ILoggedInUser } from '../types'
import LocationForm from './LocationForm'

interface IEditLocationProps {
  id: number
  locationTypeId?: number
  isDisabled?: boolean
}

const EditLocation = ({ id, isDisabled, locationTypeId }: IEditLocationProps) => {

  const loggedInUser = useAppSelector(fetchLoggedInUserSelector.data) || ({} as ILoggedInUser)

  const tenantId = loggedInUser.tenantId
  const customerId = loggedInUser.customerId


  const {
    data: location,
    isSuccess: locationLoaded,
  } = useLocationByIdQuery({
    locationId: +id,
    tenantId: tenantId ?? -1,
    customerId: customerId,
  })


  const isLoaded =
    locationLoaded

  if (!isLoaded) return <SpinnerModalBlock />

  return (
    <>
      <LocationForm location={location} isDisabled={isDisabled} locationTypeId={locationTypeId} />
    </>
  )
}

export default EditLocation
